import { Component, inject, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { UpperCasePipe } from '@angular/common';
import { Router } from '@angular/router';
import { VoyageRouteView } from '../voyage-route-view.enum';
import { VoyageSummaryModel } from '../../../../shared/models/voyage-summary.model';

@Component({
  selector: 'app-voyage-header',
  imports: [TranslateModule, UpperCasePipe],
  templateUrl: './voyage-header.html',
})
export class VoyageHeader {
  //Input y outputs
  activeVoyage = input<VoyageSummaryModel | null>(null);
  activeRouteView = input<VoyageRouteView>(VoyageRouteView.card);
  changeRouteView = output<VoyageRouteView>();

  //Services
  router: Router = inject(Router);

  //Models
  voyageRouteViews = VoyageRouteView;

  //Events
  onChangeRouteView = (newRouteView: VoyageRouteView) => {
    this.changeRouteView.emit(newRouteView);
  };
}
